import { Injectable } from '@angular/core';
import { RPCError, RPCResult } from '@campaign-portal/namespace/common/rpc.response';
import { Observable, Subscription } from 'rxjs';

export interface OptimisticUpdateConfig<R> {
	optimisticUpdate: () => void;
	request: () => Observable<R>;
	validator: (response: R) => boolean;
	revert: () => void;
	onSuccess?: (response: R) => void;
	onError?: (err: RPCResult<RPCError>) => void;
}

@Injectable({
	providedIn: 'root',
})
export class OptimisticUpdateService {
	execute<R>(config: OptimisticUpdateConfig<R>): Subscription {
		config.optimisticUpdate();

		return config.request().subscribe({
			next: (response) => {
				const isValid = config.validator(response);

				if (isValid) {
					config.onSuccess?.(response);
				} else {
					config.revert();
				}
			},
			error: (err: RPCResult<RPCError>) => {
				config.revert();
				config.onError?.(err);
			},
		});
	}
}
